export default __webpack_public_path__ + "static/media/fondo-amarillo.e03c1b01.png";